const mappings = {
  mapping_configuration: `Configuración De Mapeo`,
  view_mapping_details: "Ver detalles del mapeo",
  mapping_details: "Detalles del mapeo",
  mappings: `Cartografías`,
  mapping_not_created: `Mapeo no creado`,
  mapping_download_request_inprocess: `Solicitud de descarga en proceso`,
  description_max_length: `La descripción debe tener como máximo 100 caracteres`,
  notes: `Notas`,
};

export default mappings;
